/**
 * Skills Page - Redirects to Profile Page
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PageLayout from '../components/PageLayout';
import PageHeader from '../components/PageHeader';
import Card from '../components/Card';
import Button from '../components/Button';

const Skills = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Automatically redirect authenticated users to profile page
    if (isAuthenticated) {
      navigate('/profile');
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return (
      <PageLayout>
        <PageHeader 
          title="Skills Assessment"
          subtitle="Access player skills through your profile"
        />
        <Card variant="transparent" style={{ 
          textAlign: 'center', 
          maxWidth: '600px', 
          margin: '2rem auto',
          padding: '3rem'
        }}>
          <div style={{ 
            marginBottom: '2rem',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="var(--primary-green)" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <polygon points="16.24,7.76 14.12,14.12 7.76,16.24 9.88,9.88"/>
            </svg>
          </div>
          <h3 style={{ 
            color: 'var(--primary-green)', 
            marginBottom: '1rem',
            fontSize: '1.5rem',
            fontWeight: '700'
          }}>
            Skills Assessment Moved
          </h3>
          <p style={{ 
            color: 'rgba(255,255,255,0.9)', 
            marginBottom: '2rem',
            fontSize: '1.1rem',
            lineHeight: '1.6'
          }}>
            Skills assessments are now accessed through individual player profiles. Please sign in and visit your profile to view and manage player skills.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button 
              variant="primary" 
              onClick={() => navigate('/auth')}
            >
              Sign In
            </Button>
            <Button 
              variant="outline" 
              onClick={() => navigate('/register')}
            >
              Register
            </Button>
          </div>
        </Card>
      </PageLayout>
    );
  }

  // If authenticated, show a brief message before redirect
  return (
    <PageLayout>
      <PageHeader 
        title="Skills Assessment"
        subtitle="Redirecting to your profile..."
      />
      <Card variant="transparent" style={{ 
        textAlign: 'center', 
        maxWidth: '600px', 
        margin: '2rem auto',
        padding: '3rem'
      }}>
        <div style={{ 
          fontSize: '3rem', 
          marginBottom: '1rem',
          animation: 'spin 2s linear infinite'
        }}>
          ⚽
        </div>
        <div style={{ 
          color: 'var(--primary-green)', 
          fontSize: '1.2rem',
          fontWeight: '600',
          marginBottom: '1rem'
        }}>
          Redirecting to Profile...
        </div>
        <p style={{ 
          color: 'rgba(255,255,255,0.8)',
          marginBottom: '2rem'
        }}>
          Skills are now accessed through individual player profiles.
        </p>
        <Button 
          variant="outline" 
          onClick={() => navigate('/profile')}
        >
          Go to Profile
        </Button>
      </Card>
    </PageLayout>
  );
};

export default Skills;
